export default __webpack_public_path__ + "static/media/icon_header_logo_en.7f0d2ac6.svg";